// Hero.jsx
import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero" id="Profile">
            <div className="hero-container">
                <div className="hero-content">
                    <div className="hero-text">
                        <div className="intro-badge">
                            <span>Finance Educator & Corporate Professional</span>
                        </div>

                        <h1 className="hero-title">
                            Ankur <span className="accent">Srivastava</span>
                        </h1>

                        <p className="hero-tagline">
                            A diversified experience ranging from auditing to academia to corporate with
                            basic education in science and higher education in Finance.
                        </p>

                        <div className="experience-highlight">
                            <div className="exp-item">
                                <span className="exp-number">28+</span>
                                <span className="exp-label">Years Total Experience</span>
                            </div>
                            <div className="exp-divider"></div>
                            <div className="exp-item">
                                <span className="exp-number">15+</span>
                                <span className="exp-label">Years in Academia</span>
                            </div>
                            <div className="exp-divider"></div>
                            <div className="exp-item">
                                <span className="exp-number">13</span>
                                <span className="exp-label">Years in Corporate</span>
                            </div>
                        </div>

                        <div className="hero-description">
                            <p>
                                Always an avid learner, knowledge seeker, team leader and a team player.
                                Enjoy the areas requiring analysis, interpretation, and forecasting.
                            </p>
                        </div>

                        <div className="hero-contact-info">
                            {/* Email */}
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <svg viewBox="0 0 24 24" width="16" height="16">
                                        <path
                                            fill="currentColor"
                                            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                                        />
                                    </svg>
                                </div>

                                <a href="mailto:srivankur82@gmail.com" className="contact-link">
                                    srivankur82@gmail.com
                                </a>
                            </div>

                            {/* Phone */}
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <svg viewBox="0 0 24 24" width="16" height="16">
                                        <path
                                            fill="currentColor"
                                            d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                                        />
                                    </svg>
                                </div>

                                <a href="tel:+919212803190" className="contact-link">
                                    +91-9212803190
                                </a>
                            </div>

                            {/* Location (non-clickable) */}
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <svg viewBox="0 0 24 24" width="16" height="16">
                                        <path
                                            fill="currentColor"
                                            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                                        />
                                    </svg>
                                </div>

                                <span className="contact-text">Pune, Maharashtra</span>
                            </div>
                        </div>

                    </div>

                    <div className="hero-image">
                        <div className="image-container">
                            <img
                                src="/assets/profile.jpg"
                                alt="Ankur Srivastava"
                                className="profile-image"
                            />
                            <div className="image-frame"></div>
                            {/* <div className="floating-badge experience-badge">
                                <span>28+ Years Experience</span>
                            </div> */}
                            {/* <div className="floating-badge education-badge">
                                <span>CFA Level 1</span>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;